import { Slot } from '@radix-ui/react-slot';
import { cva, type VariantProps } from 'class-variance-authority';
import type * as React from 'react';
import { cn } from '../../styles/lib/utils';

const linkVariants = cva('underline decoration-solid decoration-1 underline-offset-2 overflow-hidden text-ellipsis', {
  variants: {
    variant: {
      default: 'font-medium text-sm font-noto text-grey-90',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

function Link({
  className,
  variant,
  href = '',
  asChild = false,
  children,
  ...props
}: React.ComponentProps<'a'> & VariantProps<typeof linkVariants> & { asChild?: boolean }) {
  const Comp = asChild ? Slot : 'a';
  return (
    <Comp data-slot="link" href={href} className={cn(linkVariants({ variant, className }))} {...props}>
      {children}
    </Comp>
  );
}

export { Link };
